module.exports = __webpack_public_path__ + "static/media/Bartlett, San Francisco, CA2.b0302a49.jpg";